function handleSliderTabClick(clickedTab) {
  // Find the parent container
  const parentContainer = clickedTab.closest(
    ".c-collapsibleSlider__content_tabsBody"
  );
  if (!parentContainer) return;

  // Get all tabs and contents within this specific container
  const slider_tabs = parentContainer.querySelectorAll(
    ".c-collapsibleSlider__tab"
  );
  const slider_tabContents = parentContainer.querySelectorAll(
    ".c-collapsibleSlider__tabContent"
  );

  // Remove active class from all tabs and contents
  slider_tabs.forEach((t) => t.classList.remove("active"));
  slider_tabContents.forEach((content) => content.classList.remove("active"));

  // Add active class to clicked tab
  clickedTab.classList.add("active");

  // Get target content and activate it
  const targetId = clickedTab.getAttribute("data-target");

  const targetContent = parentContainer.querySelector(`#${targetId}`);
  if (targetContent) {
    targetContent.classList.add("active");
  }
}
